import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { TemplateInterface } from 'models/template.model';
import { AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { PropertiesService, CreativeTemplateInterface } from '../properties.service';
import { TemplatesService } from '../templates.service';
import Swal from 'sweetalert2';
import { Property } from 'models/property.model';
import { SecurityService } from '../security.service';
import { NgForm } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-first-time-setup',
  templateUrl: './first-time-setup.component.html',
  styleUrls: ['./first-time-setup.component.scss']
})
export class FirstTimeSetupComponent implements OnInit, AfterViewInit {
  displayErrorMessage: boolean = false;

  
  private currentStep: number = 0;
  private contentLoaded: boolean = false;
  private details: any = {};

  //New Property
  public newProperty: Property;
  public highlightFields: boolean = false;
  public creatingProperty: boolean = false;
  public errorCreatingPropertyMsg: string = '';
  public cleanHost: string = "";
  public dirtyHost: string = "";
  public domainResponse: string = "";
  public domainResponseCode: number = 0;
  public purchaseDomainFlag: boolean;
  ownDomainFlag: boolean;



  //Template edit
  public selectedTemplate: TemplateInterface;
  private creativeHeadline: string;
  private creativeDescription: string;
  private creativeSubheadline: string;
  private creativeLink: string;
  private creativeImage: string;
  private trackingCodes: string;
  private pixelCode: string;
  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  uploadProgress: any;
  downloadURL: any;


  validateMoneyWebsite() {
    if (!this.dirtyHost || !this.dirtyHost.includes('.')) {
      this.highlightFields = true;
    } else {
      this.highlightFields = false;
      this.nextStep();
    }
  }
  
  validateSafeWebsite() {
    if (!this.cleanHost || !this.cleanHost.includes('.')) {
      this.highlightFields = true;
    } else {
      this.highlightFields = false;
      this.nextStep();
    }
  }

  nextStep() {
    this.currentStep = this.currentStep + 1;
  }
  
  previousStep() {
    this.currentStep = this.currentStep - 1;
  }

  constructor(private router: Router, private securityService: SecurityService, private authService: AuthService, private afStorage: AngularFireStorage, private properties: PropertiesService, private templateService: TemplatesService, private layoutService: LayoutService) { }

  ngOnInit() {
    this.layoutService.fullScreen = true;

  }

  ngAfterViewInit() {
    console.log('Loading user setup...');
    
    let that = this;
    setTimeout(() => {
      that.contentLoaded = true;
      that.cleanHost = that.authService.userData.uid.substr(0, 20);
      that.properties.createSubdomainURL(that.cleanHost).then(() => that.cleanHost = `${that.authService.userData.uid.substr(0, 20)}.cloakn.com`);
      that.cleanHost = `${that.authService.userData.uid.substr(0, 20)}.cloakn.com`;
    }, 500);
  }


  generateSafeSite() {
    Swal.fire({
      title: 'Confirm Create Safe Website',
      text: "This will build a safe website for you to use, continue?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, build it!'
    }).then((result) => {
      if (result.value) {
        this.useTemplate().then(success => {
          Swal.fire(
            'New Safe Website!',
            `You have successfully set a new safe website up!`,
            'success'
          ).then(result => {
            this.nextStep();
          });
        }).catch(error => {
          Swal.fire(
            'Error creating safe website!',
            `We experienced some issues creating your safe website, please try again or submit a ticket.`,
            'error'
          );
        });
      }
    });
  }

  changeTemplate(event: Event, template: TemplateInterface) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    console.log(`Setting template to ${template.title}`);
    this.properties.current.template = template;
  }

  selectTemplate(template: TemplateInterface) {
    if (this.selectedTemplate && this.selectedTemplate.previewUrl === template.previewUrl) {
      this.selectedTemplate = null;
    } else {
      this.selectedTemplate = template;
      this.updateProperty();
    }
  }

  updateProperty() {
    if (!this.authService.userData) return;
    this.newProperty = new Property({
      _client_id: this.authService.userData.uid,
      _id: new Date().getTime().toString(),
      clean_template_id: 1,
      clean_template_public: this.selectedTemplate ? this.selectedTemplate._id : '',
      configuration: {
        _id: new Date().getTime().toString(),
        _property_id: '',
        configuration: {
          allowedBrowerHeaders: [],
          allowedCountries: [],
          blockedCities: [],
          blockedPostalCodes: [],
          allowedISPs: [],
          allowedTimezones: [],
          allowedUserAgents: [],
          blockedBrowerHeaders: [],
          blockedCountries: [],
          blockedISPs: [],
          blockedTimezones: [],
          blockedUserAgents: [],
          urlContains: ''
        },
        options: {
          deadbolt: "on",
          facebook: "on"
        }
      },
      dirty_url: this.dirtyHost,
      hostname: this.cleanHost ? this.cleanHost.toLowerCase() : '',
      icon: 'feather',
      name: this.cleanHost,
      redirect: true,
      redirect_url: this.sanitizeDirtyUrl(this.dirtyHost),
      template: this.selectedTemplate,
      title: this.dirtyHost
    });

    this.properties.currentProperty = this.newProperty;

    console.log(`New Property: `, this.newProperty);

    this.properties.getURLMetadata(this.dirtyHost);
  }

  buildProperty() {
    let that = this;
    Swal.fire({
      title: 'Are you sure?',
      text: "You will be able to use your new cloaked domain immediately, this will consume one of your available properties.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, create it!'
    }).then((result) => {

      if (result.value) {

        that.properties.createProperty(that.authService.userData.uid, that.newProperty).then((reply: boolean) => {
          that.creatingProperty = false;
          
          Swal.fire(
            `You're All Set!`,
            `Let's customize your template for ${that.cleanHost}!`,
            'success'
          );

            //We need to dns record check the cleanhost and navigate appropiately 
          // that.router.navigate(['edit_template']);
            that.nextStep();
        });
      }
    });
  }

  confirmRegister() {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this! This will permanently use one of your available domains. ",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, register it!'
    }).then((result) => {

      if (result.value) {

        this.properties.registerDomain(this.cleanHost, this.authService.userData.uid).then((success: boolean) => {
          if (success) {
            Swal.fire(
              'Registered!',
              `You are the proud new owner of ${this.cleanHost}!`,
              'success'
            );
          } else {
            Swal.fire(
              'Failed to register!',
              `We couldn't register ${this.cleanHost} on your behalf, apologies!`,
              'warning'
            );
          }

        });


      }
    });
  }

  private skipNamecheap() {
    this.layoutService.fullScreen = false;
    this.router.navigate(["configuration"]);
  }

  private askToRegisterNamecheap(formData: NgForm) {
    console.log(formData.value);
    if (formData.value && formData.value.phone && formData.value.firstName && formData.value.lastName) {
      this.displayErrorMessage = false;

      const username: string = uuidv4().substr(0, 20).replace(/-/g, '');


        console.log('createdusername ', username);
      const newUserObject = {
        newUsername: username,
        newPassword: this.authService.userData.uid.substr(0, 20),
        ...formData.value
      }

      console.log(`Sending off to heaven`, newUserObject);
      

      Swal.fire({
        title: 'Do you want us to create a free Namecheap account for you?',
        icon: 'question',
        text: 'We can automatically register and setup domains on your behalf if you allow this.',
        showCancelButton: true,
        confirmButtonText: 'Yes Please',
        cancelButtonText: 'No Thanks',
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          return this.securityService.createNamecheapUser(this.authService.userData.uid, newUserObject).then((result: any) => {
            return result;
          }).catch((error: any) => console.error('Error creating user', error));
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result: any) => {
        console.log(result.value);
        if (!result.value) return this.router.navigate(["configuration"]);

        const responseObj: any = result.value;
        if (responseObj && responseObj.ApiResponse) {
          //Check for errors
          if (responseObj.ApiResponse.Errors && responseObj.ApiResponse.Errors.length > 0) {
            const errorMessage: Array<any> = responseObj.ApiResponse.Errors[0].Error;
            if (errorMessage && errorMessage.length > 0) {
              const errorMessageText: string = errorMessage[0]._;
              console.log('Error Message: ', errorMessageText);

              Swal.fire({
                title: `Sorry, there was an error`,
                icon: 'error',
                text: 'We experienced an error from Namecheap trying to register your account: ' + errorMessageText,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Retry',
                showCancelButton: true
              }).then((result) => {
                console.log(result);
                this.layoutService.fullScreen = false;
                this.router.navigate(["configuration"]);
              })
            } 
          }

          
          //No errors, somehow, god bless
          Swal.fire({
            title: 'We have created a new Namecheap account for you!',
            text: 'Now we can easily setup new websites for you with the click of a button, cool!',
            confirmButtonText: 'Finish',
            icon: 'success'
          }).then((result) => {
            this.layoutService.fullScreen = false;
            this.router.navigate(["configuration"]);
          });
        }
      })
    } else {
      this.displayErrorMessage = true;
    }
  }

  sanitizeDirtyUrl = (url: string): string => {
    let returnValue: string = '';

    //Check if we have http://, or https://
    if (url.startsWith('http://') || url.startsWith('https://')) {
      //Fuck it, ship it 
      returnValue = url;
    } else {
      returnValue = 'http://' + url;
    }

    return returnValue;
  }

  checkDomain() {
    if (!this.cleanHost) return;
    if (this.cleanHost && this.cleanHost.length < 5) return;
    this.properties.checkDomain(this.cleanHost).then((reply: boolean) => {
      if (reply) {
        this.domainResponse = this.cleanHost + " is available!";
        this.domainResponseCode = 1;
      } else {
        this.domainResponse = "Sorry but " + this.cleanHost + " isn't available";
        this.domainResponseCode = 2;
      }
    })
  }

  disableOwnedDomain() {
    this.ownDomainFlag = false;
    this.highlightFields = false;
  }

  disablePurchaseDomain() {
    this.purchaseDomainFlag = false;
    this.highlightFields = false;
  }


  async useTemplate() {
    //Gather the variables
    const creative: CreativeTemplateInterface = {
      description: this.creativeDescription,
      headline: this.creativeHeadline,
      image: this.downloadURL,
      link: this.creativeLink,
      subheadline: this.creativeSubheadline
    }

    console.log('building template with variables', creative);
    await this.properties.setTemplateHTML(this.properties.current, this.properties.current.dirty_url, creative, this.trackingCodes ? this.trackingCodes : '', this.pixelCode ? this.pixelCode : '');
  }

  upload(event) {
    // this.afStorage.upload(`/ad_creatives/${this.authService.userData.uid}`, event.target.files[0]);

    const file = event.target.files[0];
    const filePath = `${this.authService.userData.uid}_${this.properties.current._id}`;
    const task = this.afStorage.upload(filePath, file).then(() => {
      const ref = this.afStorage.ref(filePath);
      const downloadURL = ref.getDownloadURL().subscribe(url => {
        const Url = url; // for ts
        this.downloadURL = url; // with this you can use it in the html
      });
    });
  }
}
